<div
  class="content"
  gdGap="8px"
  gdColumns="40% repeat(2, 1fr)"
  gdAreas="cloudCredentials sshConnections sshKeypairs"
  gdColumns.lt-lg="50% auto"
  gdColumns.lt-md="50% auto"
  gdColumns.lt-sm="auto"
  gdColumns.lt-xs="auto"
  gdAreas.lt-lg="cloudCredentials cloudCredentials | sshConnections sshKeypairs"
  gdAreas.lt-md="cloudCredentials cloudCredentials | sshConnections sshKeypairs"
  gdAreas.lt-sm="cloudCredentials | sshConnections | sshKeypairs"
  gdAreas.lt-xs="cloudCredentials | sshConnections | sshKeypairs"
>
  <div *ngFor="let card of cards" class="backup-creds" [gdArea]="card.name">
    <ix-conf-table fxFlex [conf]="card.tableConf"></ix-conf-table>
  </div>
</div>
